import React from "react";
import clientConfig from "../../client-config";
import BasePortableText from "@sanity/block-content-to-react";
import { serializers } from "./serializers";
import { cn } from "../lib/helpers";

import * as styles from "./portableText.module.css";

// Some blocks arrive from Sanity without a `markDefs` array (e.g. when
// created programmatically), which crashes block-content-to-hyperscript's
// buildMarksTree when a span references a mark.
const normalizeBlocks = (blocks) =>
  blocks.map((block) =>
    block._type === "block" && !block.markDefs
      ? { ...block, markDefs: [] }
      : block
  );

const PortableText = ({ blocks, className, style, compact }) => blocks ? (
  <div className={cn(styles.portableText, compact && styles.compact, className)} style={style}>
    <BasePortableText
      blocks={normalizeBlocks(blocks)}
      serializers={serializers}
      {...clientConfig.sanity}
    />
  </div>
) : null;

export default PortableText;
